import React, { useEffect, useState, useSyncExternalStore } from "react";
import Card from "../../../components/common/Card";
import "./AddFuelDetails.css";
import {
  getFuelDetails,
  getShiftDetails1,
  getSiteDetails,
  getVehicles,
  saveDetailsTrips,
  uploadfilesgeneric,
  vehicleListVendors,
  vehicleTypes,
} from "../../../services/vehicleService";
import { withErrorHandler } from "../../../utils/tryCatchHandler";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import { FormikConsumer, useFormik } from "formik";
import InfoIcon from "@mui/icons-material/Info";

import {
  Autocomplete,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Pagination,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { AutoComplete, Avatar, DatePicker, Grid, IconButton } from "rsuite";
import { toast } from "react-toastify";
import TripDetailsForm from "../../../components/common/TripDetailForm";
// import Modal from "../../components/modals/ReusableModal";
// import BootstrapModal from "../../components/modals/ReusableModal";
import DetailModal from "../../../components/modals/DetailModal";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../redux/features/authSliceandSidebar";
import {
  GetFuelDetails,
  getFuelDetailsVehicle,
  getLastRefillService,
  getRemainingQuantity,
  saveDetailFuel,
} from "../../../services/FuelService";
import { off } from "rsuite/esm/DOMHelper";
import { common_axios } from "../../../App";
import { useNavigate } from "react-router-dom";
// import { DatePicker } from "rsuite";
const AddFuelDetails = () => {
  function generate(element) {
    return [0, 1, 2].map((value) =>
      React.cloneElement(element, {
        key: value,
      })
    );
  }
  const Demo = styled("div")(({ theme }) => ({
    backgroundColor: (theme.vars || theme).palette.background.paper,
  }));
  const [activeTab, setActiveTab] = useState("");
  const [dense, setDense] = React.useState(false);
  const [key, setKey] = useState(0);

  const [activeId, setActiveId] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [selectedRadio, setSelectedRadio] = useState("active");
  const [showModal, setShowModal] = useState(false);
  const [previousData, setPreviousData] = useState(null);
  const [formData, setFormData] = useState({
    employeeType: "permanent",
    department: "",
    employeeId: "",
    fullName: "",
    contact: "",
    email: "",
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [detailObj, setDetailObj] = useState(null);
  const [lastFuel, setLastFuel] = useState("");
  const [addedList, setAddedList] = useState([]);
  const [portalFields, setPortalfields] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [sitesList, setSitesLsit] = useState([]);
  const [showIndex, setShowIndex] = useState(0);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [shiftList, setShiftList] = useState([]);
  const [paginationPage, setPaginationPage] = useState(0);
  const [vehicleList, setVehicleList] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [responseList, setResponseList] = useState([]);
  const [vehicleVendorList, setVehicleVendorList] = useState([]);
  const [uploadfiles, setUploadfiles] = useState([]);
  const [searchState, setSearchState] = useState(null);
  const [singleArray, setSingleArray] = useState([]);

  const [fuelList, setFuelList] = useState([]);
  const [remainingfuel, setRemainingFuel] = useState([]);
  const navigate = useNavigate();

  const [forceHit, setForcehit] = useState(false);

  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isLogin = useSelector((x) => x.authSliceandSidebar.isLogin);
  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form submitted:", formData);
  };

  const getFuelDetails = async (list) => {
    await GetFuelDetails().then((res) => {
      if (res && res?.data?.statusDescription?.statusCode == 200) {
        // console.log(res.data);
        setFuelList(res.data.fuelTypeList);

        let arr = list.map((x) => {
          // // console.log(x);
          if (x.fieldType == "dropdown") {
            // console.log(x);
            return {
              ...x,
              list: res.data.fuelTypeList,
              showValue: "fuelType",
              sentValue: "fuelType",
            };
          } else {
            return { ...x };
          }
        });
        setPortalfields(arr);
        setKey(Math.random());
      }
    });
  };
  const getShiftDetails = async () => {
    setShiftList([]);
    withErrorHandler(
      await getShiftDetails1().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setShiftList(res.data.shiftDetails);
          formik.setFieldValue("shiftId", res.data.shiftDetails[0].shiftId);

          formik.setFieldValue("shiftName", res.data.shiftDetails[0].name);

          // setSelectedRadio(res.data.shiftDetails[0].shiftId);
        } else {
        }
      })
    );
  };

  const getVehiclees = async () => {
    setVehicleList([]);
    withErrorHandler(
      await vehicleTypes().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setVehicleList(res.data.data);
          if (localStorage.getItem("vehicleName") != null) {
            setActiveTab(localStorage.getItem("vehicleName"));
            // setActiveId(localStorage.getItem("vehicleTypeId"));
            formik.setFieldValue(
              "vehicleTypeId",
              localStorage.getItem("vehicleTypeId")
            );
            formik.setFieldValue(
              "vehicleName",
              localStorage.getItem("vehicleName")
            );
          } else {
            setActiveTab(res.data.data[0].name);
            setActiveId(res.data.data[0].vehicleTypeId);
            formik.setFieldValue(
              "vehicleTypeId",
              res.data.data[0].vehicleTypeId
            );
            formik.setFieldValue("vehicleName", res.data.data[0].name);
          }
          // setSelectedRadio(res.data.shiftDetails[0].shiftId);
        } else {
        }
      })
    );
  };
  const getSites = async () => {
    setSitesLsit([]);
    withErrorHandler(
      await getSiteDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          // console.log(res.data);
          setSitesLsit(res.data.siteDetails);
          formik.setFieldValue(
            "tripDate",
            moment(new Date()).format("YYYY-MM-DD")
          );
          if (!forceHit) {
            dispatch(setLoader(false));
          }
          dispatch(setLoader(false));
          // setForcehit(false);
          formik.setFieldValue("siteIdState", res.data.siteDetails[0]);
          formik.setFieldValue("siteId", res.data.siteDetails[0].siteId);
        } else {
        }
      })
    );
  };

  const getVendorDetails = async (id) => {
    if (!formik.values.shiftId) {
      return;
    }
    setLastFuel("");

    dispatch(setLoader(true));
    setVehicleVendorList([]);

    let formdata = {
      vehicleTypeId: formik.values.vehicleTypeId,
      shiftId: formik.values.shiftId,
      siteId: formik.values.siteId,
      tripDate: formik.values.tripDate,
      fieldCategory: formik.values.vehicleName,
      fieldMenu: "Add Fuel Details",
    };

    await getFuelDetailsVehicle(formdata).then((res) => {
      dispatch(setLoader(false));
      if (res && res.data?.statusDescription?.statusCode == 200) {
        setVehicleVendorList(res.data.vehicleDetails);

        getFuelDetails(res.data.portalFields);
      } else {
        toast.warn(res.data?.statusDescription?.description);
        setVehicleVendorList([]);
      }
    });
  };

  const formik = useFormik({
    initialValues: {
      siteId: null,
      shiftId: null,
      tripDate: null,
      siteIdState: null,
      tripDateState: new Date(),
      vehicleTypeId: null,
      vehicleName: "",
      shiftName: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      // console.log(values);
      let arr = [];

      if (singleArray?.length == 0) {
        toast.error("Atleast one entry is required for submit");
        return;
      }

      if (uploadfiles?.length === 0) {
        toast.error("files are required");
        return;
      }

      singleArray?.forEach((ele) => {
        let formdata = ele;
        arr.push(formdata);
        formdata["workingHours"] = Number(ele.workingHours);
      });
      // console.log(arr);
      const indiaTime = new Date().toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      let arr1 = arr.map((x) => {
        return {
          ...x,
          ...x.response,
          vehicleTypeId: formik.values.vehicleTypeId,
          refillDate: formik.values.tripDate + " " + indiaTime,
          vendorId: x.vendor.vendorId,
        };
      });

      // console.log(arr1);

      await saveDetailFuel(arr1).then((res) => {
        if (res && res.data.statusDescription.statusCode == 200) {
          toast.success(res.data.statusDescription.description);

          let arr = [];
          // console.log(res.data);
          if (res.data.fuelDetailLogL1List?.length > 0) {
            res.data.fuelDetailLogL1List.forEach((x) => {
              arr.push(x.id);
            });
          }
          if (res.data.fuelDetailLogL2List?.length > 0) {
            res.data.fuelDetailLogL2List.forEach((x) => {
              arr.push(x.id);
            });
          }

          // console.log(arr);
          resetForms();
          // navigate("/viewFuelDetails");

          uploadfilesApi(arr);
        } else {
          toast.error(res.data.statusDescription.description);
        }
      });
    },
  });

  useEffect(() => {
    if (isLogin) {
      if (!formik.values.vehicleTypeId) {
        getVehiclees();
      }
      dispatch(setLoader(true));
      setKey(Math.random());
      getShiftDetails();
      getSites();
      getRemainingQuantity1();
    }
  }, [isLogin, formik.values.vehicleTypeId]);

  const resetForms = (type) => {
    if (type) {
      setUploadfiles([]);
    }
    setKey(Math.random());
    // setAddedList([]);
    // setVehicleVendorList([]);
    setPreviousData(null);
    document.getElementById("reset_id")?.click();
    setShowIndex(0);
    setSearchKey("");
    setSearchState(null);
    let e;
    // formik.handleReset(e);
    setForcehit(true);
    dispatch(setLoader(false));
  };

  useEffect(() => {
    if (
      (formik.values.vehicleTypeId && formik.values.shiftId,
      formik.values.siteId &&
        formik.values.tripDate &&
        formik.values.vehicleName)
    ) {
      setAddedList([]);
      setLastFuel("");
      getVendorDetails();
      setSearchKey("");
      setSearchState(null);
      setSearchKey("");
      setSearchState(null);
    }
  }, [
    formik.values.vehicleTypeId,
    formik.values.shiftId,
    formik.values.siteId,
    formik.values.tripDate,
  ]);

  const getRemainingQuantity1 = async () => {
    await getRemainingQuantity({}).then((res) => {
      console.log(res);
      if (res?.data?.statusDescription?.statusCode == 200) {
        setRemainingFuel(res.data.fuelRemainingList);
      }
    });
  };

  const getLastRefill = async (data, prefilled) => {
    let { vehicleId } = prefilled;
    setLastFuel("");
    let formdata = {
      vehicleId,
      ...data,
    };
    await getLastRefillService(formdata).then((res) => {
      console.log(res);
      if (res?.data?.statusDescription?.statusCode == 200) {
        console.log(res.data);
        setLastFuel(res.data.data);
      }
    });
  };
  // useEffect(() => {
  //   const callApiInSequence = async () => {
  //     dispatch(setLoader(true));

  //     getShiftDetails()
  //       .then(getSites)

  //   };
  //   if (isLogin) {
  //     callApiInSequence();
  //   }
  // }, [formik.values.vehicleTypeId, isLogin]);

  const uploadfilesApi = async (arr) => {
    // console.log(arr);
    let formdata = new FormData();

    formdata.append("fuelIds", arr.join(","));

    uploadfiles.forEach((x) => {
      formdata.append("files", x);
    });

    formdata.append("userId", localStorage.getItem("userId"));

    await uploadfilesgeneric(formdata, "/fuel/v1/save-fuel-attachments").then(
      (res) => {
        if (res && res.data.statusDescription.statusCode == 200) {
          // console.log("files saved ");
          getRemainingQuantity1();
          setUploadfiles([]);
          setSingleArray([]);
          resetForms();
          // navigate("/viewFuelDetails");
        }
      }
    );
  };

  return (
    <div className="staff-management">
      {/* First Row - Tabs */}
      <div className="tabs-container margin-bottom-3">
        {vehicleList?.map((x) => {
          return (
            <>
              <button
                key={x.vehicleTypeId}
                className={`tab ${activeTab === x.name ? "active" : ""}`}
                onClick={(e) => {
                  setActiveTab(x.name);
                  setVehicleVendorList([]);

                  formik.handleReset(e);
                  formik.setFieldValue("vehicleTypeId", x.vehicleTypeId);
                  formik.setFieldValue("vehicleName", x.name);
                }}
              >
                {x.name}
              </button>
            </>
          );
        })}
      </div>

      {/* Second Row - Controls */}
      <div className="row controls-container mt-3 mx-1">
        <div className="col-md-2 site_div">
          <FormControl sx={{ padding: "2px" }} fullWidth>
            <InputLabel shrink={true}>
              Site <span className="text text-danger">* </span>
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={formik.values.siteIdState}
              required
              size="small"
              name="siteIdState"
              label="Projects"
              onChange={(e) => {
                formik.handleChange(e);
                // console.log(e.target.value);
                formik.setFieldValue("siteId", e.target.value.siteId);
              }}
              MenuProps={{
                disableAutoFocusItem: true, // Prevents auto-focusing the first item
                disableEnforceFocus: true, // Prevents focus trapping
                disableRestoreFocus: true, // Prevents restoring focus to input
              }}
            >
              <MenuItem value={0} style={{ fontSize: "12px" }}>
                {" "}
                Select Site
              </MenuItem>
              {sitesList.length > 0 &&
                sitesList.map((data) => {
                  return (
                    <MenuItem
                      key={data.siteId}
                      value={data}
                      style={{ fontSize: "11px" }}
                    >
                      {" "}
                      {data.siteName}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </div>
        <div className="col-md-auto date-picker">
          <input
            type="date"
            name="tripDate"
            value={formik.values.tripDate}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) => {
              // console.log(e);
              formik.handleChange(e);
            }}
          />
        </div>
        <div className="col-md-auto radio-group">
          {shiftList?.map((x, i) => {
            return (
              <>
                <label key={i}>
                  <input
                    type="radio"
                    name="status"
                    value={
                      formik.values.shiftId == x.shiftId ? "active" : "inactive"
                    }
                    checked={formik.values.shiftId == x.shiftId}
                    onChange={(e) => {
                      // setSelectedRadio(x.shiftId);
                      formik.setFieldValue("shiftId", x.shiftId);
                    }}
                  />
                  {x.name}
                </label>
              </>
            );
          })}
        </div>

        <div className="col-md-auto yellow_apply">
          <button
            className="btn yellow_btn_1 "
            type="button"
            onClick={(e) => {
              getVendorDetails();
              setKey(Math.random());
              setPreviousData(null);
            }}
          >
            {" "}
            Apply <i className="fa fa-left-arrow"></i>{" "}
          </button>

          {isMobile && (
            <button
              className="btn btn-primary mx-1  p-0  yellow_btn_2"
              type="button"
              onClick={(e) => {
                localStorage.setItem(
                  "vehicleTypeId",
                  formik.values.vehicleTypeId
                );
                localStorage.setItem("vehicleName", formik.values.vehicleName);
                navigate("/viewFuelDetails");
              }}
            >
              View
            </button>
          )}
        </div>
      </div>

      {/* Your Existing Card with Form */}
      <Card
        title={` ${
          formik.values.vehicleName?.charAt(0).toUpperCase() +
          formik.values.vehicleName?.slice(1)
        } Fuel Details  : ${formik.values.siteIdState?.siteName}   >  ${
          formik.values.shiftName
        }   >   ${moment(formik.values.tripDate).format("DD-MMM-YYYY")}`}
      >
        <form onSubmit={handleSubmit}>
          {vehicleVendorList.length > 0 && (
            <div className="row mb-1 srch_row">
              <div className="col-md-5 offset-md-4">
                {remainingfuel.map((x) => {
                  return (
                    <div className="row">
                      <div className="col-md-4 col-6">{x.fuelType} </div>
                      <div className="col-md-4  col-6 offset-md-2">
                        {x.totalRemainingQuantity} L{" "}
                      </div>
                    </div>
                  );
                })}
                <hr />
              </div>
              <div className="d-flex justify-content-end col-md-3  col-8  mb-1 inp_search_div">
                <Autocomplete
                  options={vehicleVendorList}
                  className="inp_search"
                  sx={{ width: 300 }}
                  value={searchState}
                  style={{ padding: "2px" }}
                  getOptionLabel={(option) => option?.registrationNumber || ""}
                  onChange={(e, newValue, reason) => {
                    if (reason == "clear") {
                      setSearchState(null);
                      setSearchKey("");
                      return;
                    }
                    if (newValue) {
                      setKey(Math.random());
                      setSearchState(newValue);
                      setSearchKey(newValue?.registrationNumber);
                      let filter = vehicleVendorList.filter((x) => {
                        return (
                          x.registrationNumber == newValue?.registrationNumber
                        );
                      });
                      // console.log(filter);

                      if (filter?.length > 0) {
                        vehicleVendorList.forEach((x, i) => {
                          if (filter[0].vehicleId == x.vehicleId) {
                            setShowIndex(i);
                            setKey(Math.random());
                          }
                        });
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Search Vehicle" />
                  )}
                />

                {/* <button
                  className="btn  srch_blue"
                  type="button"
                  onClick={(e) => {
                    let filter = vehicleVendorList.filter((x) => {
                      return x.registrationNumber == searchKey;
                    });
                    // console.log(filter);

                    if (filter?.length > 0) {
                      vehicleVendorList.forEach((x, i) => {
                        if (filter[0].vehicleId == x.vehicleId) {
                          setShowIndex(i);
                          setKey(Math.random());
                        }
                      });
                    }
                  }}
                >
                  {" "}
                  <i className="fa fa-search " />
                </button> */}
              </div>
            </div>
          )}

          {vehicleVendorList.length > 0 ? (
            <>
              <div className="container-fluid main_container pb-1 ">
                {vehicleVendorList.map((x, i) => {
                  let arr = [];

                  if (showIndex == i && portalFields.length > 0) {
                    return (
                      <TripDetailsForm
                        formFields={portalFields}
                        prefilled={x}
                        formSubmitted={formSubmitted}
                        index={i}
                        key={key}
                        editData={previousData}
                        resetTrigger={resetTrigger}
                        exportData={(e, index) => {
                          // console.log(e);
                          if (e) {
                            x["response"] = e;
                            setResponseList(arr);
                            setFormSubmitted(false);
                          }
                        }}
                        setErrors={(e) => {
                          // console.log(e);
                        }}
                        exportAddition={(e, i) => {
                          // console.log(e);
                          setSingleArray([]);

                          x["response"] = e;
                          let arr = [];
                          let arr1 = [...addedList];

                          let filearr = [];

                          Object.keys(e).forEach((x) => {
                            if (x.includes("file")) {
                              console.log(e[x]);
                              e[x].forEach((fl) => {
                                filearr.push(fl);
                              });
                              // filearr.push(e[x][0]);
                            }
                          });
                          console.log(filearr);
                          setUploadfiles(filearr);
                          if (true) {
                            arr.push(x);
                            arr1.push(x);
                            // console.log(x);
                            let aer1 = vehicleVendorList.filter((x1) => {
                              return x1.vehicleId != x.vehicleId;
                            });
                            setSingleArray(arr);
                            setVehicleVendorList(aer1);
                            formik.handleSubmit(e);
                          }

                          setResetTrigger(true);
                          setAddedList(arr1);
                          setPreviousData(null);
                          if (searchKey != "") {
                            setShowIndex(0);
                          }
                          setShowIndex(0);
                          setKey(Math.random());

                          setSearchKey("");
                        }}
                        exportBlur={(e, prefilled) => {
                          console.log(e, prefilled);
                          getLastRefill(e, prefilled);
                        }}
                      />
                    );
                  }
                })}
              </div>
              <div className="row mt-3">
                <div className="prev_next d-flex justify-content-end">
                  <Stack spacing={2}>
                    <Pagination
                      onChange={(event, value) => {
                        // console.log(value);
                        setShowIndex(value - 1);
                        setKey(Math.random());
                        setPreviousData(null);
                        // setShowIndex(value);
                      }}
                      page={showIndex + 1}
                      count={
                        vehicleVendorList.length ? vehicleVendorList.length : ""
                      }
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Stack>
                </div>
              </div>
            </>
          ) : addedList?.length > 0 && vehicleVendorList?.length == 0 ? (
            <div className="d-block text-center">
              <h4>All Vehicles Added </h4>
            </div>
          ) : (
            <div className="d-block text-center">
              <h4> Please Select Site ,Date and Shift </h4>
            </div>
          )}
        </form>

        {addedList?.length > 0 && (
          <div>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Demo>
                <List dense={dense}>
                  {/* <div
                    className="row added_card  d-flex justify-content-between"
                    style={{ fontWeight: "bold" }}
                  >
                    <div className="col-md-2">Vendor Name</div>
                    <div className="col-md-auto">Vehicle No</div>
                    <div className="col-md-auto">Hr Reading</div>
                    <div className="col-md-auto">Type</div>
                    <div className="col-md-auto">Rate</div>
                    <div className="col-md-auto">Quantity</div>
                    <div className="col-md-auto">Total Amt</div>
                  </div>

                  {addedList?.map((x, i) => {
                    return (
                      <>
                        <div className="container-fluid main_container p-2 mt-2    ">
                          <div className="row   d-flex justify-content-between">
                      
                            <div className="col-md-2">{x?.vendor?.name}</div>
                            <div className="col-md-auto">
                              {x?.registrationNumber}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.hourReading}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.fuelType}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.fuelRate}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.quantity}
                            </div>
                            <div className="col-md-auto">
                              {x?.response?.totalAmount}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })} */}

                  {addedList?.map((x) => {
                    return (
                      <>
                        <div className="container-fluid">
                          <div className="card">
                            <div className="card-body">
                              <div className="main_row_tab">
                                <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Vendor Name</span> <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.vendor?.name}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Vehicle Number</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.registrationNumber}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Hour Reading</span> <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.hourReading}
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Fuel Type</span> <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.fuelType}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Fuel Rate</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.fuelRate}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Quantity</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.quantity}
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Total Amount</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.totalAmount}
                                    </div>
                                  </div>
                                  {/* <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span> Hard Cubic Mtr</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.hardCubicMeter}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Soft Cubic Mtr</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.softCubicMeter}
                                    </div>
                                  </div> */}
                                </div>

                                {/* <div className="row">
                                  <div className="col-md-4 d-flex txt_col">
                                    <div className="col-4 d-flex justify-content-between">
                                      <span>Trps Ct</span>
                                      <span>:</span>
                                    </div>
                                    <div
                                      className="col-8 text-center"
                                      style={{ fontWeight: "600" }}
                                    >
                                      {x?.response?.tripsCount}
                                    </div>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </List>
              </Demo>
            </Grid>
          </div>
        )}
        {lastFuel != "" && (
          <div className="">
            <p>{lastFuel}</p>
          </div>
        )}
      </Card>

      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                Cancel Confirmation
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="cancelclose"
              ></button>
            </div>
            <div className="modal-body">
              Are you want to cancel filling details
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary yellow_btn "
                onClick={(e) => {
                  formik.handleReset(e);
                  setVehicleVendorList([]);
                  setUploadfiles([]);
                  setAddedList([]);
                  setSearchKey("");
                  getVehiclees();

                  document.getElementById("cancelclose")?.click();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <DetailModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title="User Details"
        details={detailObj}
        btnTitle={"Logout"}
      />
    </div>
  );
};

export default AddFuelDetails;
